import jsPDF from "jspdf";

/** Adds a generated timestamp and "Page N of M" footer to every jsPDF page. */
export const addPdfPageNumberFooter = (doc: jsPDF): void => {
  const pageCount = doc.getNumberOfPages();
  const generatedAt = new Date().toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  for (let page = 1; page <= pageCount; page += 1) {
    doc.setPage(page);
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const footerOffset = (8 * 72) / (25.4 * doc.internal.scaleFactor);
    doc.setFontSize(8);
    doc.setTextColor(90);
    const footerY = pageHeight - footerOffset;
    doc.text(`Generated on ${generatedAt}`, footerOffset, footerY);
    doc.text(`Page ${page} of ${pageCount}`, pageWidth - footerOffset, footerY, { align: "right" });
  }
};
